<template>
  <v-row>
    <v-col
      cols="4"
      style="height: calc(100vh - 300px); overflow: scroll"
      class="py-0"
    >
      <v-card style="position: sticky; top: 0px" flat>
        <suppliers-search
          :destination-id="destinationId"
          @supplier-edit="onSupplierEdit"
        ></suppliers-search>
      </v-card>
    </v-col>

    <v-col cols="8" style="height: calc(100vh - 300px); overflow: scroll">
      <open-group-builder-day-by-day-item
        v-for="day in duration"
        :key="day"
        :day="day"
        :duration="duration"
        :group-items="items"
        @change="onDayChange"
        @delete="onItemDelete"
        @onItemRemarks="$emit('onItemRemarks', $event)"
        @onExtraRemove="onExtraRemove"
      ></open-group-builder-day-by-day-item>
      <div v-if="debug">
        <code>{{ items }}</code>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import SuppliersSearch from "../../templates/builder/SuppliersSearch";
import OpenGroupBuilderDayByDayItem from "./OpenGroupBuilderDayByDayItem";

export default {
  name: "open-group-builder-day-by-day",

  props: {
    duration: {
      type: Number,
      default: () => 0,
    },
    destinationId: {
      type: String,
      default: () => "",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    SuppliersSearch,
    OpenGroupBuilderDayByDayItem,
  },

  data() {
    return {
      debug: false,
    };
  },

  methods: {
    onSupplierEdit(payload) {
      this.$emit("supplier-edit", payload);
    },
    onDayChange(payload) {
      if (payload.added) {
        const el = { ...payload.added.element, startDay: payload.day };
        const existing = this.items.find((item) => item.uid == el.uid);
        if (existing) {
          const maxDuration = this.itemMaxDuration(el.serviceType, el.startDay);
          if (el.duration > maxDuration) {
            el.duration = maxDuration;
          }
          if (el.extras) {
            for (const extra of el.extras) {
              extra.startDay = payload.day;
              if (extra.duration > maxDuration) {
                extra.duration = maxDuration;
              }
            }
          }
          this.$emit("update-item", { ...el });
        } else {
          if (el.extras) {
            const maxDuration = this.itemMaxDuration(el.serviceType, el.startDay);
            for (const extra of el.extras) {
              extra.startDay = payload.day;
              if (extra.duration > maxDuration) {
                extra.duration = maxDuration;
              }
            }
          }
          this.$emit("add-item", { ...el });
        }
      }
      // update order for all items in the day
      let order = Number(payload.day) * 100;
      let c = 1;
      for (const updateItemUid of payload.order) {
        const updateItem = this.items.find((item) => item.uid == updateItemUid);
        if (updateItem) {
          updateItem.order = order + c;
          c++;
        }
      }
    },
    onItemDelete(payload) {
      this.$emit("remove-item", payload);
    },
    onExtraRemove(payload) {
      this.$emit("onExtraRemove", payload);
    },
    itemMaxDuration(type, day) {
      let maxDuration = this.duration - day;
      if (type != "ACCOMMODATION") {
        maxDuration++;
      }
      if (maxDuration == 0) {
        maxDuration = 1;
      }
      return maxDuration;
    },
  },
};
</script>

<style>
.fixed {
  position: fixed;
  top: 56px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/open-groups/builder/OpenGroupBuilderDayByDay.vue